var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("title-view", [
        _vm._v("\n    " + _vm._s(_vm.$t("contact_9")) + "\n  ")
      ]),
      _c(
        "div",
        { staticClass: "page-contact-form__contacts grid-center" },
        [
          _c(
            "contact-view",
            { staticClass: "col-4_md-12" },
            [
              _c("template", { slot: "title" }, [
                _vm._v("\n        " + _vm._s(_vm.$t("footer_6")) + "\n      ")
              ]),
              _c("template", { slot: "subtitle" }, [
                _c(
                  "a",
                  { attrs: { href: _vm.getPhone(_vm.$t("project_3")) } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("project_3")) +
                        "\n        "
                    )
                  ]
                )
              ])
            ],
            2
          ),
          _c(
            "contact-view",
            { staticClass: "col-4_md-12" },
            [
              _c("template", { slot: "title" }, [
                _vm._v("\n        " + _vm._s(_vm.$t("footer_9")) + "\n      ")
              ]),
              _c("template", { slot: "subtitle" }, [
                _c(
                  "a",
                  { attrs: { href: _vm.getPhone(_vm.$t("project_4")) } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("project_4")) +
                        "\n        "
                    )
                  ]
                )
              ])
            ],
            2
          ),
          _c(
            "contact-view",
            { staticClass: "col-4_md-12" },
            [
              _c("template", { slot: "title" }, [
                _vm._v("\n        " + _vm._s(_vm.$t("footer_11")) + "\n      ")
              ]),
              _c("template", { slot: "subtitle" }, [
                _c(
                  "a",
                  { attrs: { href: _vm.getPhone(_vm.$t("project_4")) } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("project_12")) +
                        "\n        "
                    )
                  ]
                )
              ])
            ],
            2
          )
        ],
        1
      ),
      _c("contact-form-view"),
      _c(
        "section",
        { staticClass: "page-contact-form__email" },
        [
          _c(
            "contact-view",
            { staticClass: "col-4_md-12", attrs: { variant: "invert" } },
            [
              _c("template", { slot: "title" }, [
                _vm._v("\n        " + _vm._s(_vm.$t("project_10")) + "\n      ")
              ]),
              _c("template", { slot: "subtitle" }, [
                _c(
                  "a",
                  { attrs: { href: _vm.getEmail(_vm.$t("project_5")) } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("project_5")) +
                        "\n        "
                    )
                  ]
                )
              ])
            ],
            2
          )
        ],
        1
      ),
      _c(
        "section",
        { staticClass: "grid-noGutter" },
        _vm._l(_vm.$t("contacts_list"), function(contact, index) {
          return _c(
            "contact-full-view",
            { key: index, staticClass: "col-6_xs-12" },
            [
              _c("template", { slot: "image" }, [
                _c("picture", [
                  _c("source", {
                    attrs: {
                      media: "--small",
                      alt: contact.imageAlt,
                      "data-srcset": contact.image.small
                    }
                  }),
                  _c("source", {
                    attrs: {
                      media: "--large",
                      alt: contact.imageAlt,
                      "data-srcset": contact.image.large
                    }
                  }),
                  _c("img", {
                    staticClass: "lazyload",
                    attrs: {
                      "data-sizes": "auto",
                      alt: contact.imageAlt,
                      "data-src": contact.image.src
                    }
                  })
                ])
              ]),
              _c("template", { slot: "header" }, [
                _vm._v("\n        " + _vm._s(contact.title) + "\n      ")
              ]),
              _c(
                "template",
                { slot: "detail" },
                [
                  _vm._l(contact.street, function(infoLocal, i) {
                    return _c("div", { key: i }, [
                      _vm._v("\n          " + _vm._s(infoLocal) + "\n        ")
                    ])
                  }),
                  _c("br"),
                  _c("a", { attrs: { href: contact.link.href } }, [
                    _vm._v(_vm._s(contact.link.number))
                  ])
                ],
                2
              ),
              _c("template", { slot: "map" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: contact.map,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }
                  },
                  [
                    _c("button-view", { attrs: { variant: "small" } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("button_3")) +
                          "\n          "
                      )
                    ])
                  ],
                  1
                )
              ])
            ],
            2
          )
        }),
        1
      ),
      _c("footer-follow-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e9a474c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e9a474c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contact.vue
// module id = 593
// module chunks = 7